// THIS VALUES ARE USED DURING CLIENT APP COMPILATION, PLEASE DO NOT MOVE
const initialAppId = 'app_pvVjT1Z2DSsq7aSq2Sg2G7'
const initialProjectId = 'proj_4fCUW6BYiw'
// eslint-disable-next-line import/newline-after-import, @typescript-eslint/no-var-requires
const initialBuildOrdersOnApp = require('./buildOrders.loaded.json')
const initialRunningMode = 'premium'
const initialCustomFontName = undefined
// #################

export const initialAppState = {
    appId: initialAppId,
    projectId: initialProjectId,
    buildOrders: initialBuildOrdersOnApp,
    runningMode: initialRunningMode,
    customFontName: initialCustomFontName,
} as const
